// 国搜首页 地方 功能按钮显示隐藏地方列表
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // 浏览器全局变量(root 即 window)
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {
  function mShowHide() {

    // 移入移出防抖动清除 timeID
    var __enterClearTimeID__;
    var __leaveClearTimeID__;
    $('.qieHuanWrap-v3-difang').on({
      'mouseenter': function () {
        //
        clearTimeout(__enterClearTimeID__);
        clearTimeout(__leaveClearTimeID__);
        __enterClearTimeID__ = setTimeout(function () {
          $('.difang-more-con ').show();
        }, 200);
      },
      'mouseleave': function () {
        //
        clearTimeout(__enterClearTimeID__);
        clearTimeout(__leaveClearTimeID__);
        __leaveClearTimeID__ = setTimeout(function () {
          $('.difang-more-con ').hide();
        }, 200);
      }
    });

    //设置
    $('#nav_setup').on({
      'mouseenter': function () {
        //
        clearTimeout(__enterClearTimeID__);
        clearTimeout(__leaveClearTimeID__);
        __enterClearTimeID__ = setTimeout(function () {
          $('.nav_setup_con ').show();
        }, 200);
      },
      'mouseleave': function () {
        //
        clearTimeout(__enterClearTimeID__);
        clearTimeout(__leaveClearTimeID__);
        __leaveClearTimeID__ = setTimeout(function () {
          $('.nav_setup_con ').hide();
        }, 200);
      }
    });



  }
  return mShowHide;
}));



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/mShowHide.js
// module id = 0c97e13e9547e882060d
// module chunks = 1